import { render, staticRenderFns } from "./DecisionEditorItem.vue?vue&type=template&id=d855488e&scoped=true&"
import script from "./DecisionEditorItem.vue?vue&type=script&lang=js&"
export * from "./DecisionEditorItem.vue?vue&type=script&lang=js&"
import style0 from "./DecisionEditorItem.vue?vue&type=style&index=0&id=d855488e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d855488e",
  null
  
)

export default component.exports